import { makePostWithParameters, axiosPost } from './api.js';
import { captureException } from './sentryService.js';

const selectCreditCard = makePostWithParameters('/checkout/editpayment/selectZppCreditCard');
const deleteCreditCard = makePostWithParameters('/checkout/editpayment/deleteZppCreditCard');
const deleteAllCreditCards = makePostWithParameters('/checkout/editpayment/deleteAllZppCreditCards');
/**
 * Store the Credit Card data (Adyen, Braintree) in a checkout session.
 *
 * @param params The request params
 * @param body Credit Card details body
 * @return The boolean value indicate if this operation is successful
 */
const storeCreditCard = async (params, body) => {
    const { csrfToken, psp } = params;
    const url = '/checkout/editpayment/storeZppCreditCardInSession';
    let storeCreditCardBody;
    if (psp === 'ADYEN') {
        storeCreditCardBody = {
            adyenZppInput: body,
        };
    }
    else {
        storeCreditCardBody = {
            braintreeZppInput: body,
        };
    }
    try {
        const response = await axiosPost(url, csrfToken, storeCreditCardBody, params);
        return response.status === 200;
    }
    catch (error) {
        throw captureException({ error });
    }
};

export { deleteAllCreditCards, deleteCreditCard, selectCreditCard, storeCreditCard };
//# sourceMappingURL=creditCardService.js.map
